<template>
  <section
    :class="[
      'section_base section_box',
      {'is-full-height': isFullHeight},
      {'has-no-padding': hasNoPadding},
    ]"
  >
    <!--I didn't use computed class here because I don't want the div tag unless hasColumns is true-->
    <div v-if="hasColumns" class="columns is-multiline my-0"><slot></slot></div>
    <template v-else><slot></slot></template>
  </section>
</template>

<script>
export default {
  name: "SectionBox",
  props: {
    hasColumns: {
      type: Boolean,
      default: false
    },
    isFullHeight: {
      type: Boolean,
      default: false
    },
    hasNoPadding: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
// See section.scss for section_base styles
</style>
